<template>
<div id="app">
  <headercomponent />
  <contentview />
  <formcomponent />
</div>
</template>

<script>
import headercomponent from './components/headercomponent.vue';
import contentview from './components/contentview.vue';
import formcomponent from './components/formcomponent.vue';
export default {
  components: {
    headercomponent,
    contentview,
    formcomponent,
  },
}
</script>
<style>
@import "assets/fonts/stylesheet.css";
@import "assets/css/lms-form.css";
@import "assets/css/lms-form-custom.css";
@import "assets/css/style.css";
@import "assets/css/swiper.min.css";
@import "assets/css/swiper-custom.css";
</style>
